import React, { ChangeEvent, useEffect } from 'react';
import { FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation, useNavigate } from 'react-router-dom';
import theme from '../../utils/theme';

interface SearchInputProps {
  searchText: string;
  setSearchText: (text: string) => void;
  placeholderText?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ searchText, setSearchText, placeholderText }) => {
  const navigate = useNavigate();
  const { search } = useLocation()
  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
    setTimeout(() => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('keyword', event.target.value);
      searchParams.set('page', '1');
      navigate(`?${searchParams.toString()}`);
    }, 2000);
  };

  useEffect(()=>{
    const searchParams = new URLSearchParams(window.location.search);
    if(searchParams.get('keyword') === null){
      setSearchText("")
    }
  },[search,setSearchText])

  return (
    <FormControl variant="outlined">
      <OutlinedInput
        sx={{ width: 200 }}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon sx={{ color: theme.palette.grey[400] }} />
          </InputAdornment>
        }
        size="small"
        placeholder={placeholderText || "Search"}
        value={searchText}
        onChange={onSearchChange}
      />
    </FormControl>
  );
};

export default SearchInput;
